module.exports = __webpack_public_path__ + "img/dljcndc.4d87808.png";